import React, {useEffect, useState} from 'react';

interface CaptchaProps {
    skip: boolean;
    setSkip: (skip: boolean) => any;
}

export function Captcha3(props: CaptchaProps) {

    //state array with all selected boxes
    const [selectedPieces, setSelectedPieces] = useState([""]);

    function removeSelected(selected: string){
        var array = [...selectedPieces]; // make a separate copy of the array
        var index = array.indexOf(selected)
        if (index !== -1) {
            array.splice(index, 1);
            return array;
        }
        else{
            return array;
        }
    }

    function addSelected(selected:string){
        var array = [...selectedPieces]; // make a separate copy of the array
        array.push(selected);
        return array;
    }


    useEffect(() => {
        props.setSkip(selectedPieces.length == 1);
    },[selectedPieces]);

    return(
        <div>
            <div className={"wrapper"}>
                <div className={(selectedPieces.includes("piece1") ? "selected" : "")} id={"piece1"}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece1"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece1") ? removeSelected("piece1") : addSelected("piece1"))}}>
                    </div>
                </div>
                <div className={(selectedPieces.includes("piece2") ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece2"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece2") ? removeSelected("piece2") : addSelected("piece2"))}}>
                    </div>
                </div>
                <div className={(selectedPieces.includes("piece3") ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece3"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece3") ? removeSelected("piece3") : addSelected("piece3"))}}>
                    </div>
                </div>

            </div>

            <div className={"wrapper"}>
                <div className={(selectedPieces.includes("piece4") ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece4"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece4") ? removeSelected("piece4") : addSelected("piece4"))}}>
                    </div>
                </div>
                <div className={(selectedPieces.includes("piece5") ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece5"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece5") ? removeSelected("piece5") : addSelected("piece5"))}}>
                    </div>
                </div>
                <div className={(selectedPieces.includes("piece6") ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece6"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece6") ? removeSelected("piece6") : addSelected("piece6"))}}>
                    </div>
                </div>
            </div>

            <div className={"wrapper"}>
                <div className={(selectedPieces.includes("piece7") ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece7"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece7") ? removeSelected("piece7") : addSelected("piece7"))}}>
                    </div>
                </div>
                <div className={(selectedPieces.includes("piece8") ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece8"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece8") ? removeSelected("piece8") : addSelected("piece8"))}}>
                    </div>
                </div>
                <div className={(selectedPieces.includes("piece9") ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle3 piece9"
                         onClick={event => {
                             setSelectedPieces(selectedPieces.includes("piece9") ? removeSelected("piece9") : addSelected("piece9"))}}>
                    </div>
                </div>
            </div>
        </div>
    )

}


